
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node/standard_info_page",
      function () {
        return require("private-next-pages/node/standard_info_page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node/standard_info_page"])
      });
    }
  